import React from "react";
import ISOServiceIndia9001 from "../../../components/ISO Certificates/ISO Common/ISOServiceIndia9001";
import ISOCertificationCost9001 from "../../../components/ISO Certificates/ISO Common/ISOCertificationCost9001";
import ISOBenifit9001 from "../../../components/ISO Certificates/ISO Common/ISOBenifit9001";
import ISOHeader45001 from "../../../components/ISO Certificates/ISO 45001 2018/ISOHeader45001";
import ISOContent45001 from "../../../components/ISO Certificates/ISO 45001 2018/ISOContent45001";

const ISO450012018 = () => {
  return (
    <div>
      <ISOHeader45001 />
      <ISOContent45001 />
      <ISOServiceIndia9001 />
      <ISOCertificationCost9001 />
      <ISOBenifit9001 />
    </div>
  );
};

export default ISO450012018;
